import React from 'react';
import { ContactFlowModule } from './contact-flow-module';

import {
  StyledContactFlow,
  StyledContactFlowContainer,
  StyledContactFlowModule
} from './contact-flow.styles';

import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';

export const ContactFlow = ({ isContactUsExperiment }) => {
  return (
    <StyledContactFlow primary>
      <HeaderTextBlock size="responsive">
        <HeaderTextBlockTitle>Contact Us</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <StyledContactFlowContainer>
        <StyledContactFlowModule>
          <ContactFlowModule isContactUsExperiment={isContactUsExperiment} />
        </StyledContactFlowModule>
      </StyledContactFlowContainer>
    </StyledContactFlow>
  );
};
